import { useTranslation } from '@msdk/common'
import { FieldProps, useEntityFromCollection } from '@msdk/forms'
import React from 'react'

import { MuSelectorAutocomplete } from './MuSelectorAutocomplete'

export function MuSelectorDestination({ node, onChange }: FieldProps) {
  const t = useTranslation()
  const label: string = t('FRM_MEASUREMENT_UNIT_DESTINATION', 'Measurement unit destination')

  const entity = useEntityFromCollection(node.value?.entityId ?? '')
  const sourceFieldValue: string = entity?.fields['MEASUREMENT_UNIT_SOURCE']?.value as string

  return (
    <>
      <MuSelectorAutocomplete
        node={node}
        onChange={onChange}
        label={label}
        filters={{ sameFamilyOf: sourceFieldValue }}
      ></MuSelectorAutocomplete>
    </>
  )
}
